import { NEXT_PAGE, START_MOBILE_QUIZ, UPDATE_QUESTION_ONE, UPDATE_MEAT_MULTIPLIER, UPDATE_MEAT_PERCENT, UPDATE_FLAVORS, SKIP_QUESTIONS, RESET_QUIZ, SHOW_RESULTS } from './mutations'

const getDefaultState = () => {
  return {
    dietIndexUI: 0,
    mobileQuizStarted: false,
    resultsShown: false,
    userSkippedMeat: false,
    questions: [
      {
        question: 'On a typical day (i.e. think about what you ate yesterday), how often do you consume the following foods?',
        instructions: 'You can select multiple. If a category is not part of your normal diet, you can leave it blank by not selecting any meals or snacks. Select “snack” if you eat an item throughout the day, but it isn’t part of your meal.',
        questions: [
          {
            title: 'Meat and Seafood',
            titleExample: '(i.e. beef, pork, chicken, fish)',
            options: [
              { label: 'Breakfast', val: 1 },
              { label: 'Lunch', val: 1.5 },
              { label: 'Dinner', val: 1.5 },
              { label: 'Snack', val: 0.5 },
            ],
            selected: []
          },
          {
            title: 'Dairy',
            options: [
              { label: 'Breakfast', val: 1 },
              { label: 'Lunch', val: 1.5 },
              { label: 'Dinner', val: 1.5 },
              { label: 'Snack', val: 0.5 },
            ],
            selected: []
          },
          {
            title: 'Eggs',
            options: [
              { label: 'Breakfast', val: 1 },
              { label: 'Lunch', val: 1.5 },
              { label: 'Dinner', val: 1.5 },
              { label: 'Snack', val: 0.5 },
            ],
            selected: []
          },
          {
            title: 'Fruits',
            options: [
              { label: 'Breakfast', val: 0.5 },
              { label: 'Lunch', val: 1 },
              { label: 'Dinner', val: 1 },
              { label: 'Snack', val: 0.5 },
            ],
            selected: []
          },
          {
            title: 'Vegetables',
            options: [
              { label: 'Breakfast', val: 1 },
              { label: 'Lunch', val: 1.5 },
              { label: 'Dinner', val: 1.5 },
              { label: 'Snack', val: 0.5 },
            ],
            selected: []
          },
          {
            title: 'Grains',
            titleExample: '(i.e. bread, rice, oatmeal, pasta)',
            options: [
              { label: 'Breakfast', val: 1 },
              { label: 'Lunch', val: 1.5 },
              { label: 'Dinner', val: 1.5 },
              { label: 'Snack', val: 0.5 },
            ],
            selected: []
          },
          {
            title: 'Nuts',
            options: [
              { label: 'Breakfast', val: 1 },
              { label: 'Lunch', val: 1 },
              { label: 'Dinner', val: 1 },
              { label: 'Snack', val: 0.5 },
            ],
            selected: []
          },
        ]
      },
      {
        question: 'When you eat a meal that includes meat (or seafood), what’s your usual ratio of meat to non-meat items?',
        value: 2,
        labels: [
          { title: 'Mostly <br /> non-Meat', example: '(i.e. chicken salad, pasta with meat)' },
          { title: 'Half &<br /> Half', example: '(i.e. beef stir fry,<br/> shrimp tacos)' },
          { title: 'Mostly <br /> Meat', example: '(i.e. hamburger,<br/> steak)' }
        ]
      },
      {
        question: 'Of the meat you eat, roughly what percentage of it is:',
        options: [
          { title: 'Beef', value: 0 },
          { title: 'Pork', value: 0 },
          { title: 'Chicken', value: 0 },
          { title: 'Fish', value: 0 }
        ]
      },
      {
        question: 'What kinds of flavors do you like?',
        instructions: 'This will help us give our best recommendation for alternative recipes we think you’ll like!',
        questions: [
          {
            title: 'Sweetness',
            value: 2,
            labels: ['Savory', 'Sweet']
          },
          {
            title: 'Spice',
            value: 2,
            labels: ['Mild', 'Spicy']
          },
          {
            title: 'Flavor',
            value: 2,
            labels: ['bland', 'bold']
          }
        ]
      }
    ]
  }
}

const state = getDefaultState()

const getters = {

}

const mutations = {
  [NEXT_PAGE] (state) {
    state.dietIndexUI++
  },
  [START_MOBILE_QUIZ] (state) {
    state.mobileQuizStarted = true
  },
  [UPDATE_QUESTION_ONE] (state, payload) {
    state.questions[0] = payload
  },
  [UPDATE_MEAT_MULTIPLIER] (state, payload) {
    state.questions[1].value = payload
  },
  [UPDATE_MEAT_PERCENT] (state, payload) {
    state.questions[2].options = payload
  },
  [UPDATE_FLAVORS] (state, payload) {
    state.questions[3].questions = payload
  },
  [SKIP_QUESTIONS] (state) {
    // Set meat multiplier to 0 (Defaults to 2)
    state.questions[1].value = 0
    // Set user to skipped questions
    state.userSkippedMeat = true
    // Send user to last question
    state.dietIndexUI = 3
  },
  [RESET_QUIZ] (state) {
    Object.assign(state, getDefaultState())
  },
  [SHOW_RESULTS] (state) {
    state.resultsShown = true
  }
}

const actions = {
  resetQuizState ({ commit }) {
    commit('RESET_QUIZ')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
